export const environment = {
  production: true,
  occBaseUrl: "https://api.c9guxrh1t0-osbornedi1-p1-public.model-t.cc.commerce.ondemand.com",
  paypal: {
    id: 'AQm2p3BTLUOz9o4iAcD_CoYouFEmFLMf4N1nXQrgf26OlKRqCiNaVxFMvHuUUE9fvkfxZo-OqIvKF_Ey',
    src: 'https://www.paypal.com/sdk/js',
    installments: {
      active: true,
      threshold: 60.0,
    },
  },
  gtmId: {
    osbornestore: 'GTM-P2VXRLT',
    'osbornestore-public': 'GTM-WKCJJLB',
    riofrio: 'GTM-MVNJBKK',
  },
  reCaptcha: {
    enabled: true,
    scriptSrc: 'https://www.google.com/recaptcha/api.js',
    onloadCallbackName: 'recaptchaCallback',
    v2: {
      siteKey: '6LfDaf8eAAAAAAFtczB04T0abSBTzDV3Q-0fybJE',
    },
    v3: {
      siteKey: '6LfmCpMqAAAAAJgXYF7dUjZCVl8e1jGCxPRp4Eli',
    }
  },
  emarsysConfig: {
    merchantId: '16AD13C5377829C9',
    testMode: false,
  },
  optInMerchantId: '5310373180',
  siteUrl: {
    public: 'https://www.osborne.es/',
    private: 'https://espacio-privado.osborne.es/',
    riofrio: 'https://www.caviarderiofrio.com/'
  }
};
